import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { PRICING_CTA_LABEL } from '../utils/checkout';
const trustItems = ['Instant download', 'Print-ready PDF', 'Secure payment', 'Lifetime access'];
export function PricingSection() {
  return <section id="pricing" aria-labelledby="pricing-title" className="scroll-mt-6 bg-cream px-5 py-20 md:py-28" data-id="element-187" data-mp="1ja0f23wi7xmc">
      <Reveal className="mx-auto max-w-2xl" data-id="element-188" data-mp="1n9r2bxmtnvm4">
        <div className="text-center" data-id="element-189" data-mp="1s9n55tjs9h03">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber" data-id="element-190" data-mp="1s8lwfvq8p6lj">LAUNCH PRICE</p>
          <h2 id="pricing-title" className="mt-4 text-3xl font-extrabold tracking-tight text-pine md:text-4xl" data-id="element-191" data-mp="1x9rqbwvmyzwn">
            Special Launch Offer
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-slate-body" data-id="element-192" data-mp="2up6aepcwa14">
            Everything above, in one download, at a price built to get it into as many hands as possible.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-card border-2 border-amber bg-white shadow-lift" data-id="element-193" data-mp="1mgoelaxrp9kc">
          <p className="bg-pine px-6 py-4 text-center font-display text-xs font-bold uppercase tracking-[0.12em] text-white sm:text-sm" data-id="element-194" data-mp="1hq81jrxuzpyi">
            LACROSSE READY 360™ — THE COMPLETE SYSTEM
          </p>
          <div className="p-6 md:p-9" data-id="element-195" data-mp="17s1wx2ko45py">
            <dl className="space-y-4 text-sm" data-id="element-196" data-mp="17td3tb9ettla">
              <PriceLine label="6 Complete Volumes" price="$173" data-id="element-197" data-mp="25fiwgssj2q4q" />
              <PriceLine label="5 Exclusive Bonuses" price="$124" data-id="element-198" data-mp="25er7i0tfrqnf" />
              <div className="flex items-center justify-between border-t border-slate-line pt-4 font-display text-sm font-bold uppercase tracking-wide text-pine" data-id="element-199" data-mp="20hhc84jd8kro">
                <dt data-id="element-200" data-mp="1rg1bypm9lz16">TOTAL VALUE</dt>
                <dd className="text-slate-body line-through" data-id="element-201" data-mp="1repzm1er7iyg">$297</dd>
              </div>
            </dl>

            <div className="mt-8 rounded-card bg-amber-tint px-6 py-8 text-center" data-id="element-202" data-mp="k2z7v9npfalf">
              <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber" data-id="element-203" data-mp="fzjeqnaufsdh">TODAY&apos;S PRICE</p>
              <p className="mt-2 flex items-baseline justify-center gap-2 font-display font-extrabold tracking-tight text-pine" data-id="element-204" data-mp="hj2vuv3p41d7">
                <span className="text-[4.5rem] leading-none md:text-[5.5rem]" data-id="element-205" data-mp="meryj7b0hydq">32</span>
                <span className="text-xl md:text-2xl" data-id="element-206" data-mp="7jc24vmylqe6">USD</span>
              </p>
              <p className="mt-3 text-xs text-slate-body" data-id="element-207" data-mp="chdiv9wwxdmh">One payment. Yours forever.</p>
            </div>

            <CTAButton target="checkout" label={PRICING_CTA_LABEL} className="mt-8 w-full" data-id="element-208" data-mp="3uv3bais09o2p" />

            <ul className="mt-7 grid grid-cols-2 gap-x-4 gap-y-3 border-t border-slate-line pt-6" data-id="element-209" data-mp="3is29kb048oc">
              {trustItems.map(item => <li key={item} className="flex items-center gap-2 text-xs font-medium text-slate-body" data-id="element-210" data-mp="3pxkyuies4qpy">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-turquoise" strokeWidth={3} aria-hidden="true" data-id="element-211" data-mp="3bxsf571o7arh" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-slate-line pb-4" data-id="element-212" data-mp="2sd1vegy9as81">
      <dt className="font-medium text-ink" data-id="element-213" data-mp="36cuhfyyu8k9o">{label}</dt>
      <dd className="whitespace-nowrap font-semibold text-pine" data-id="element-214" data-mp="369f4p2smznbf">{price}</dd>
    </div>;
}